<template>
    <div>
        <div class="wrapper">
            <layoutimg :dataList="dataList" :md="4" :cols="6"></layoutimg>
        </div>
    </div>
</template>
<script>
    import layoutimg from "@/forumcomponents/indexList";
    export default {
        data() {
            return {
                dataList: [],
            };
        },
        created() {
            this.getActivityCategory();
        },
        methods: {
            getActivityCategory() {
                this.$forumApi
                    .activityCategory()
                    .then((res) => {
                        if (res.code == 200) {
                            // console.log('activityCategory---------',res.data);
                            res.data.forEach((item, index) => {
                                this.dataList.push({
                                    title: item.name,
                                    titleImg: item.titleImg,
                                    id: item.id,
                                    type:item.type
                                });
                                console.log('this.dataList',this.dataList);
                                
                            });
                        }
                    });
            },
        },
        components: {
            layoutimg
        },
    };
</script>
<style lang="scss" scoped>
    @media (min-width:992px) {
        .wrapper {
            width: 1150px;
            margin: 1.5rem auto 0px auto;
        }
    }
</style>